/*
 * Same-day Sydney delivery messaging.
 * Detects greater-Sydney visitors via coarse IP geolocation (cached 24h),
 * then shows a live countdown to the daily cutoff (Mon-Fri) or a priority
 * next-business-day message outside that window. Non-Sydney visitors see nothing.
 * Config comes from window.SDD_CONFIG (set in theme.liquid from theme settings).
 */
(function () {
  if (window.__sddBooted) return; // header renders twice; only boot once
  window.__sddBooted = true;

  var cfg = window.SDD_CONFIG || {};
  if (cfg.enabled === false) return;

  var SYDNEY = { lat: -33.8688, lng: 151.2093 };
  var RADIUS_KM = typeof cfg.radiusKm === 'number' ? cfg.radiusKm : 50;
  var TZ = 'Australia/Sydney';
  var GEO_ENDPOINT = cfg.geoEndpoint || 'https://ipapi.co/json/';
  var CACHE_KEY = 'sdd_geo_v1';
  var CACHE_MS = (cfg.cacheHours || 24) * 3600 * 1000;
  var TODAY_COPY = cfg.todayCopy || '%time% left to order for same-day Sydney delivery, $20 (select Local Delivery at checkout)';
  var LATER_COPY = cfg.laterCopy || 'Order now for priority Sydney delivery %day%, $20 (select Local Delivery at checkout)';

  var cutoffHour = 10, cutoffMin = 30;
  if (typeof cfg.cutoff === 'string' && /^\d{1,2}:\d{2}$/.test(cfg.cutoff)) {
    var parts = cfg.cutoff.split(':');
    cutoffHour = parseInt(parts[0], 10);
    cutoffMin = parseInt(parts[1], 10);
  }

  // Debug: ?sdd_now=2026-06-25T09:00 fakes the current Sydney time (for testing the states).
  var NOW_OVERRIDE = null;
  try {
    var qNow = new URLSearchParams(window.location.search).get('sdd_now');
    if (qNow) {
      var t = new Date(qNow);
      if (!isNaN(t.getTime())) NOW_OVERRIDE = { base: t, at: Date.now() };
    }
  } catch (e) {}

  var badges = document.querySelectorAll('.sdd-badge');
  if (!badges.length) return;

  getGeo(function (geo) {
    if (!isSydney(geo)) return; // fail safe: show nothing
    render();
    setInterval(render, 1000);
  });

  function isSydney(geo) {
    if (!geo) return false;
    var country = (geo.country || '').toUpperCase();
    if (country && country !== 'AU') return false;
    if (typeof geo.lat === 'number' && typeof geo.lng === 'number') {
      return haversine(geo.lat, geo.lng, SYDNEY.lat, SYDNEY.lng) <= RADIUS_KM;
    }
    // Fallback when coordinates are missing
    return (geo.city || '').toLowerCase() === 'sydney';
  }

  function getGeo(cb) {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        if (cached && (Date.now() - cached.ts) < CACHE_MS) {
          cb(cached.geo);
          return;
        }
      }
    } catch (e) {}

    var controller = null, timer = null;
    var opts = { headers: { 'Accept': 'application/json' } };
    if ('AbortController' in window) {
      controller = new AbortController();
      opts.signal = controller.signal;
      timer = setTimeout(function () { controller.abort(); }, 3500);
    }

    fetch(GEO_ENDPOINT, opts)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (timer) clearTimeout(timer);
        if (!d || d.error) { cb(null); return; }
        var geo = {
          lat: typeof d.latitude === 'number' ? d.latitude : parseFloat(d.latitude),
          lng: typeof d.longitude === 'number' ? d.longitude : parseFloat(d.longitude),
          region: d.region || d.region_code || '',
          city: d.city || '',
          country: d.country_code || d.country || ''
        };
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), geo: geo })); } catch (e) {}
        cb(geo);
      })
      .catch(function () { if (timer) clearTimeout(timer); cb(null); });
  }

  function sydneyNow() {
    if (NOW_OVERRIDE) return new Date(NOW_OVERRIDE.base.getTime() + (Date.now() - NOW_OVERRIDE.at));
    return new Date(new Date().toLocaleString('en-US', { timeZone: TZ }));
  }

  function render() {
    var now = sydneyNow();
    var day = now.getDay(); // 0 Sun .. 6 Sat
    var isWeekday = day >= 1 && day <= 5;
    var cutoff = new Date(now);
    cutoff.setHours(cutoffHour, cutoffMin, 0, 0);

    var html, mode;
    if (isWeekday && now < cutoff) {
      var totalSec = Math.floor((cutoff - now) / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      var timeStr = h > 0
        ? (h + 'h ' + pad(m) + 'm ' + pad(s) + 's')
        : (m + 'm ' + pad(s) + 's');
      var timeHtml = '<span class="sdd-stopwatch" aria-hidden="true">&#9201;</span> <span class="sdd-countdown">' + timeStr + '</span>';
      html = TODAY_COPY.replace('%time%', timeHtml);
      mode = 'today';
    } else {
      html = LATER_COPY.replace('%day%', '<strong>' + nextBusinessDayLabel(now) + '</strong>');
      mode = 'later';
    }

    for (var i = 0; i < badges.length; i++) {
      var textEl = badges[i].querySelector('.sdd-badge__text');
      if (textEl) textEl.innerHTML = html;
      badges[i].hidden = false;
      badges[i].setAttribute('data-sdd-mode', mode);
    }
  }

  function nextBusinessDayLabel(now) {
    var d = new Date(now);
    do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
    var diffDays = Math.round((stripTime(d) - stripTime(now)) / 86400000);
    if (diffDays === 1) return 'tomorrow';
    var names = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return names[d.getDay()];
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function stripTime(d) {
    var x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
  }

  function haversine(lat1, lng1, lat2, lng2) {
    var toRad = function (v) { return v * Math.PI / 180; };
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }
})();
